import { getEquipmentById } from '@/api/equipments-api'
import { equipmentKeys } from '@/hooks/equipments/query-keys'
import { createFileRoute } from '@tanstack/react-router'

export type EquipmentTabs = 'details' | 'sites' | 'interventions' | 'documents'

const allowedTabs: EquipmentTabs[] = [
  'details',
  'sites',
  'interventions',
  'documents',
]

export type EquipmentSearch = {
  tab: EquipmentTabs
  action?: 'edit' | 'import'
  page?: string
  // Sites tab filter params
  name?: string
  manufacturingYear?: string
  condition?: string
  operability?: string
  criticality?: string
  status?: string
  warranty?: string
  nextMaintenanceDate?: string
}

const filterParamKeys = [
  'page',
  'name',
  'manufacturingYear',
  'condition',
  'operability',
  'criticality',
  'status',
  'warranty',
  'nextMaintenanceDate',
] as const

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/equipments/$equipmentId'
)({
  validateSearch: (search: Record<string, unknown>): EquipmentSearch => {
    const { tab, action } = search

    const validatedTab = allowedTabs.includes(tab as EquipmentTabs)
      ? (tab as EquipmentTabs)
      : 'details'

    const result: EquipmentSearch = {
      tab: validatedTab,
      action:
        ((validatedTab === 'details' || validatedTab === 'sites') &&
          action === 'edit') ||
        (validatedTab === 'documents' && action === 'import')
          ? (action as 'edit' | 'import')
          : undefined,
    }

    for (const key of filterParamKeys) {
      const value = search[key]
      if (typeof value === 'string' && value !== '') {
        result[key] = value
      }
    }

    return result
  },
  loader: async ({ context: { queryClient }, params: { equipmentId } }) =>
    queryClient.ensureQueryData({
      queryKey: equipmentKeys.detail(equipmentId),
      queryFn: () => getEquipmentById(equipmentId),
    }),
})
